import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppComponent } from "./app.component";
import { WCupRankingBootstrapComponent } from "./wcup-ranking/components/wcup-ranking-bootstrap/wcup-ranking-bootstrap.component";
import { WorldRankingBootstrapComponent } from "./world-ranking/components/world-ranking-bootstrap/world-ranking-bootstrap.component";
import { BootstrapWorldRecordsComponent } from './world-records/components/bootstrap-world-records/bootstrap-world-records.component';
import { BootstrapPriceForPrecisionComponent } from './prize-for-precision/components/bootstrap-price-for-precision/bootstrap-price-for-precision.component';

const routes: Routes = [
  { path: "", component: AppComponent, pathMatch: "full" },
  {
    path: "",
    children: [

      {
        path: "world-records",
        loadChildren:() => import('./world-records/world-records.module').then(m => m.WorldRecordsModule)
      },

      {
        path: "records-du-monde",
        loadChildren:() => import('./world-records/world-records.module').then(m => m.WorldRecordsModule)

      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
